"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableRowCellAdditionalProperty = exports.resultsTableRowCellAdditionalPropertyDefinition = void 0;
exports.resultsTableRowCellAdditionalPropertyDefinition = {
    view: { label: 'Results Table Row Cell Additional' },
    constraints: [
        {
            name: 'oneOfProperties',
            argument: [
                'results-table-cell-value-asset',
                'results-table-cell-value-float',
                'results-table-cell-value-integer',
                'results-table-cell-value-percent',
                'results-table-cell-value-points',
                'results-table-cell-value-text',
                'results-table-cell-value-timestamp',
            ],
        },
    ],
    type: 'one-of-container',
    multiple: true,
    name: 'results-table-row-cell-additional',
};
const isResultsTableRowCellAdditionalProperty = (prop) => {
    return prop.name === exports.resultsTableRowCellAdditionalPropertyDefinition.name;
};
exports.isResultsTableRowCellAdditionalProperty = isResultsTableRowCellAdditionalProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1yb3ctY2VsbC1hZGRpdGlvbmFsLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcmVzdWx0cy10YWJsZS1yb3ctY2VsbC1hZGRpdGlvbmFsLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsK0NBQStDLEdBQUc7SUFDN0QsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLG1DQUFtQyxFQUFFO0lBQ3BELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLGlCQUFpQjtZQUN2QixRQUFRLEVBQUU7Z0JBQ1IsZ0NBQWdDO2dCQUNoQyxnQ0FBZ0M7Z0JBQ2hDLGtDQUFrQztnQkFDbEMsa0NBQWtDO2dCQUNsQyxpQ0FBaUM7Z0JBQ2pDLCtCQUErQjtnQkFDL0Isb0NBQW9DO2FBQ3JDO1NBQ0Y7S0FDRjtJQUNELElBQUksRUFBRSxrQkFBa0I7SUFDeEIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsbUNBQW1DO0NBQ1YsQ0FBQTtBQUkxQixNQUFNLHVDQUF1QyxHQUFHLENBQUMsSUFBa0IsRUFBaUQsRUFBRTtJQUMzSCxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssdURBQStDLENBQUMsSUFBSSxDQUFBO0FBQzNFLENBQUMsQ0FBQTtBQUZZLFFBQUEsdUNBQXVDLDJDQUVuRCJ9